/**
 * @generated SignedSource<<14e4ae28cb65da8f2a86d2ee966a3271>>
 * @relayHash 205d8656124320ceb37efacccc0a9807
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8d935fb2412a7dbc2071fcb8ca17c75dc2c7725330b2328d48969357d2e55218

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4AppsContentViewQuery$variables = {
  cloudId: string;
  entityAriApps?: string | null;
  ownerAri?: string | null;
  skipOrderQuery: boolean;
};
export type Nav4AppsContentViewQuery$data = {
  readonly appsOrder?: {
    readonly " $fragmentSpreads": FragmentRefs<"Nav4AppsContent_navigationCustomisation">;
  } | null;
  readonly jira: {
    readonly " $fragmentSpreads": FragmentRefs<"Nav4AppsContent">;
  };
};
export type Nav4AppsContentViewQuery = {
  response: Nav4AppsContentViewQuery$data;
  variables: Nav4AppsContentViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityAriApps"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ownerAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skipOrderQuery"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "entityAri",
    "variableName": "entityAriApps"
  },
  {
    "kind": "Variable",
    "name": "ownerAri",
    "variableName": "ownerAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "label"
},
v4 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v5 = {
  "kind": "ScalarField",
  "name": "url"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "Nav4AppsContentViewQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "Nav4AppsContent"
            }
          ]
        },
        "action": "THROW"
      },
      {
        "condition": "skipOrderQuery",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "appsOrder",
            "args": (v1/*: any*/),
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "Nav4AppsContent_navigationCustomisation"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Nav4AppsContentViewQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              }
            ],
            "concreteType": "JiraNavigationItemConnection",
            "kind": "LinkedField",
            "name": "globalAppNavigationItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              },
              {
                "concreteType": "JiraNavigationItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "appId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "appType"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "envLabel"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "iconUrl"
                          },
                          (v4/*: any*/),
                          {
                            "concreteType": "JiraAppSection",
                            "kind": "LinkedField",
                            "name": "sections",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "concreteType": "JiraAppNavigationItemNestedLink",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v5/*: any*/),
                                  (v4/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "settingsUrl"
                          },
                          (v5/*: any*/)
                        ],
                        "type": "JiraAppNavigationItem"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "skipOrderQuery",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "appsOrder",
            "args": (v1/*: any*/),
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
              {
                "concreteType": "SettingsMenuItemConnection",
                "kind": "LinkedField",
                "name": "sidebar",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "SettingsMenuItem",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "menuId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "visible"
                      }
                    ]
                  }
                ]
              },
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8d935fb2412a7dbc2071fcb8ca17c75dc2c7725330b2328d48969357d2e55218",
    "metadata": {},
    "name": "Nav4AppsContentViewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c7cdbee2e919012c9f4e63ba00aef4da";

export default node;
